import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import { Container } from 'reactstrap';
import { InView } from 'react-intersection-observer';

import FanFavouriteCard from 'Components/Cards/FanFavouriteCard';
import Meta from 'Components/Utility/SEO/Meta';
import Backtotopbutton from 'Components/Utility/Mobile/Backtotopbutton';
import SkeletonFanFavouriteCard from 'Components/Utility/Skeleton/SkeletonFanFavouriteCard';
import 'Components/FanFavourites/FanFavourites.scss';

const messages = defineMessages({
  title: {
    id: 'fanfavourties.title',
    defaultMessage: 'Fanatical Gamers Recommend | Fanatical',
  },
  meta_description: {
    id: 'fanfavourties.meta_description',
    defaultMessage: 'A show case of the best reviews chosen by the Fanatical Community',
  },
});

const FanFavourites = ({ intl: { formatMessage }, hits, favouriteCardNameTag }) =>
  <Container>
    <Meta
      title={formatMessage(messages.title)}
      description={formatMessage(messages.meta_description)}
      url="recommended"
      hits={hits}
      pageType="CollectionPage"
    />
    <div className="pb-5 pt-5 fan-favourites-container">
      <InView>
        {({ inView, ref }) =>
          <div className="title-container pb-5" ref={ref}>
            <div>
              <h1>
                <FormattedMessage id="fanfavourites.header" defaultMessage="Fanatical Gamers Recommend" />
              </h1>
              {!inView &&
                <div className="d-block d-sm-none">
                  <Backtotopbutton />
                </div>
              }
            </div>
          </div>
        }
      </InView>
      { isEmpty(hits) && [...Array(25).keys()].map(fakeHit =>
        <SkeletonFanFavouriteCard
          key={Math.random() + fakeHit}
        />,
      )}
      {Array.isArray(hits) && !!hits.length && hits.map(hit =>
        <FanFavouriteCard hit={hit} favouriteCardNameTag={favouriteCardNameTag} />,
      )}
    </div>
  </Container>;

FanFavourites.propTypes = {
  hits: PropTypes.arrayOf(PropTypes.shape),
  favouriteCardNameTag: PropTypes.string,
};
FanFavourites.defaultProps = {
  hits: [],
  favouriteCardNameTag: 'h3',
};


export default injectIntl(FanFavourites);
